import getLatestCategoryPath from '../constants/legacy/getLatestCategoryPath';
import slugify from './slugify';
import appendUTMParams from './utmParams';

/**
 * Create find url
 */
export default function findUrl(params) {
  const url = ['/find'];
  if (!params) {
    return '';
  }

  if (params.keywordPath) {
    const categoryRedirect = getLatestCategoryPath(params.keywordPath);
    url.push(categoryRedirect || params.keywordPath);
  } else if (params.keyword) {
    const categoryRedirect = getLatestCategoryPath(slugify(params.keyword));
    url.push(categoryRedirect || slugify(params.keyword));
  }

  if (params.suburb_url) {
    url.push(
      slugify(params.suburb_url.replace(/region|online|-region|-online/gi, ''))
    );
  } else if (params.suburb && params.state) {
    url.push(
      `${slugify(params.suburb.replace(/region|online/gi, ''))}-${slugify(
        params.state
      )}${params.postcode ? `-${params.postcode}` : ''}`
    );
  } else if (params.breadcrumbs) {
    if (params.breadcrumbs.length) {
      const firstItem = params.breadcrumbs[0];
      const lastItem = params.breadcrumbs[params.breadcrumbs.length - 1];
      url.push(`${lastItem.url_slug}-${firstItem.url_slug}`);
    }
  }

  if (params.page) {
    url.push(`p=${params.page}`);
  }

  if (params.query) {
    return appendUTMParams(`${url.join('/')}${params.query}`);
  }

  return appendUTMParams(url.join('/'));
}
